import { render, staticRenderFns } from "./RequestCardResourcesNew.vue?vue&type=template&id=25dc5016&scoped=true"
import script from "./RequestCardResourcesNew.vue?vue&type=script&lang=ts"
export * from "./RequestCardResourcesNew.vue?vue&type=script&lang=ts"
import style0 from "./RequestCardResourcesNew.vue?vue&type=style&index=0&id=25dc5016&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25dc5016",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25dc5016')) {
      api.createRecord('25dc5016', component.options)
    } else {
      api.reload('25dc5016', component.options)
    }
    module.hot.accept("./RequestCardResourcesNew.vue?vue&type=template&id=25dc5016&scoped=true", function () {
      api.rerender('25dc5016', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/onboarding/RequestCardResourcesNew.vue"
export default component.exports